export const TYPEFORM_BOOK_URL = "https://form.typeform.com/to/gIrJc530#advisor=xxxxx";

